import { ActorRepository } from '../data/actor-repository';
import { ConnectorDashboardRequest, ConnectorCountResponse } from '../types/api-types';

export class GetConnectorCountUseCase {
  constructor(private actorRepository: ActorRepository) {}

  async execute(
    operatorId: string,
    params?: Omit<ConnectorDashboardRequest, 'limit' | 'offset' | 'sortBy' | 'sortOrder'>
  ): Promise<ConnectorCountResponse> {
    return await this.actorRepository.getConnectorCount(operatorId, params);
  }
}
